import { RichTextSocialShareBlockNode } from '@cinemark/content-api-client';
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical';
import { PlatformComponent } from './platform';

type RichTextSocialShareBlockComponentProps = {
  node: SerializedBlockNode | undefined;
};

export const RichTextSocialShareBlockComponent = ({ node }: RichTextSocialShareBlockComponentProps): React.JSX.Element | null => {
  if (!node || node.type !== 'block' || !node.fields || typeof node.fields !== 'object' || node.fields.blockType !== 'socialShare') return null;

  const fields = node.fields as unknown as RichTextSocialShareBlockNode;

  return (
    <span className="flex space-x-4"
      data-test="social-share-block"
    >
      {fields.platforms.map(platform =>
        <PlatformComponent key={platform.id}
          platform={platform}
          shareMessage={fields.shareMessage}
          shareSource={fields.shareSource}
        />
      )}
    </span>
  );
};
